import React,{useState} from "react";
import SectionHeading from "./SectionHeading";
import { LANDING_PAGE_STUDENT_FEEDBACK } from "../../constants/text_constants";
import StudentFeedbackCard from "./StudentFeedbackCard";
import { useNavigate } from "react-router-dom";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import ScrollCarousel from "scroll-carousel-react";
import StudentFeedbackCarousel from "./StudentFeedbackCarousel";

const StudentFeedback = ({ feedback }) => {
  const navigate = useNavigate();
  const [isPaused, setIsPaused] = useState(false);
  if (!feedback || feedback.length === 0) return;
  const displayCards = feedback.slice(0, 3);

  return (
    <div className="-mx-[10rem] bg-[#F8FCFD] lg:my-[3rem] my-[1rem] p-10">
      <SectionHeading
        heading={LANDING_PAGE_STUDENT_FEEDBACK?.heading}
        subHeading={LANDING_PAGE_STUDENT_FEEDBACK?.subHeading}
        headingColor={"#130C40"}
      />
      <div className="flex justify-center items-center -mt-[2rem] xl:mx-[8rem] mx-[0rem] relative pb-5">
        <div className=""></div>

        {/* <div className="grid gap-[1.3rem] studentfbStyle" onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}>
          <ScrollCarousel autoplay={!isPaused} className="w-full px-4 py-2" autoplaySpeed={12} speed={2}>
            {displayCards.map((ele, i) => (
              <StudentFeedbackCard {...ele} key={i} />
            ))}
          </ScrollCarousel>
        </div> */}
        <StudentFeedbackCarousel data={displayCards}/>

      </div>
      <div className="flex items-center justify-center ">
        <button
          className="px-5 py-1 text-l font-bold text-white bg-gradient-to-r from-cyan-400 to-purple-600 rounded-full shadow-lg hover:-translate-y-1 hover:shadow-2xl transition-all"
          onClick={() => {
            navigate(UNPROTECTED_ROUTES?.feedback);
          }}
        >
          View All
        </button>
      </div>
    </div>
  );
};

export default StudentFeedback;
